import { useEffect, useState } from 'react';
import { Button, Container, Divider, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { Table } from '../../../../../../src/components';
import { request, toast } from '../../../../../../src/utils';

function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

const DETAIL_HEADER = [
    {
        header: 'Patient Name',
        accessor: (row) => `${row.patient.name}`
    },
    {
        header: 'UHID No',
        accessor: 'uhid'
    },
    {
        header: 'Adm No.',
        accessor: 'ipd_no'
    },
    {
        header: 'Mobile No.',
        accessor: 'patient.mobile'
    },
    {
        header: 'Doctor Name',
        accessor: 'consultant_detail.doctor.name'
    },
    {
        header: 'Ward',
        accessor: 'consultant_detail.room.ward.name'
    },
    {
        header: 'Room No.',
        accessor: 'consultant_detail.room.room_no'
    },
    {
        header: 'Bed',
        accessor: 'consultant_detail.bed_no'
    },
    {
        header: 'Adm Date',
        accessor: (row) => formatDate(row.date)
    },
    {
        header: 'Nur Station',
        accessor: 'consultant_detail.room.nurse_station.name'
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];


export const ReceptionEnquiry = () => {
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState('');

    const methods = useForm({
        mode: 'all'
    });
    const { handleSubmit, setValue, reset, watch } = methods;

    useEffect(() => {
        searchIPDDetails();
    }, []);


    const searchIPDDetails = async () => {
        setLoading(true);
        try {
            const response = await request('/indoor-registeration-list-admit-patient', {
                method: 'GET'
            });
            if (response?.success) {
                if (!response?.data) {
                    toast('No IPD found', { variant: 'warning' });
                } else {
                    setDetailList(response?.data);
                }
            } else {
                toast('Failed to load patient details', { variant: 'error' });
            }
        } catch (error) {
            toast('Error fetching patient details', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleUhidSearch();
    }, [input]);

    
    const handleUhidSearch= async () => {
        const lowercasedInput = input.toLowerCase().trim();
        const query = {};
        if (lowercasedInput) {
          query.name = lowercasedInput;
        }
        const response = await request('/indoor-registeration-list-admit-patient', { method: 'GET',query: query});
        if (response.success) {
          setDetailList({ loading: false, data: response?.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setDetailList({ loading: false,data:[] });
        }
      };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
    };

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto'
            }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: '100vw',
                        boxSizing: 'border-box',
                        minWidth: "100%"
                    }}
                >
                    <FormProvider methods={methods}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Reception Enquiry
                            </Typography>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
                                >
                                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                                        <MuiTextField
                                            sx={{
                                                width: '100%',
                                                padding: 0,
                                                '& .MuiInputBase-input': {
                                                    fontSize: '1.5rem', // Adjust the font size as needed
                                                    fontWeight:700
                                                },
                                            }}
                                            label="Search Patient By UHID, IPD No or Name"
                                            variant="outlined"
                                            value={input}
                                            onChange={handleChange}
                                        />
                                    </Stack>
                                    <Table
                                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                        data={detailList?.data || []}
                                        columns={DETAIL_HEADER}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper>
        </>
    );
};
